import React from 'react'

const lazyWithRetry = <T extends React.ComponentType<any>>(
  componentImport: () => Promise<{ default: T }>
): React.LazyExoticComponent<T> => {
  return React.lazy(() => {
    const maxRetries = 3

    return new Promise<{ default: T }>((resolve, reject) => {
      const retry = (attempt: number): void => {
        componentImport()
          .then(resolve)
          .catch((error) => {
            console.log(`Tentativa ${attempt} falhou.`)
            attempt < maxRetries ? setTimeout(() => retry(attempt + 1), 1000) : reject(error)
          })
      }

      retry(1)
    })
  })
}
export default lazyWithRetry
